import axios from "axios"
import React, { useState } from "react"
import CONSTANT_INFO from "../../constant/constant"
import "../../styles/global.scss"
import Button from "../Button/Button"
import { toast } from "react-toastify"
import SpinnerLoader from "../Loader/SpinnerLoader"

const categories = [
    {
        name: "development",
        title: "Development"
    },
    {
        name: "ui-ux-design",
        title: "UI/UX Design"
    },
    {
        name: "marketing",
        title: "Marketing"
    },
    {
        name: "maintenance",
        title: "Maintenance"
    },
    {
        name: "brand-development",
        title: "Brand development"
    },
    {
        name: "seo",
        title: "SEO"
    },
    {
        name: "other",
        title: "Other"
    }
]

function Form({
    context = {
        pageName: "Saigon Digital",
        pageUri: "https://saigon.digital/"
    }
}) {
    const [loadingForm, setLoadingForm] = useState(false)
    const [serverState, setServerState] = useState({
        submitting: false,
        status: null
    })

    const handleServerResponse = (ok, msg, form) => {
        setServerState({
            submitting: false,
            status: { ok, msg }
        })
        if (ok) {
            form.reset()
        }
    }
    const handleOnSubmit = async e => {
        e.preventDefault()
        const form = e.target
        setLoadingForm(true)
        const formData = new FormData(e.target)
        const config = {
            headers: {
                "Content-Type": "application/json"
            }
        }

        const categoryValue = []

        categories.forEach(category => {
            if (formData.get(category.name)) categoryValue.push(category.name)
        })

        const fields = [
            {
                name: "firstname",
                value: formData.get("firstname")
            },
            {
                name: "lastname",
                value: formData.get("lastname")
            },
            {
                name: "email",
                value: formData.get("email")
            },
            {
                name: "phone",
                value: formData.get("phone")
            },
            {
                name: "message",
                value: formData.get("message")
            },
            {
                name: "industry",
                value: categoryValue.join(", ")
            }
        ]

        await axios
            .post(
                CONSTANT_INFO.curl.hubspot_form_contact_new,
                {
                    portalId: process.env.GATSBY_HUBSPOT_PORTAL,
                    formGuid: process.env.GATSBY_HUBSPOT_FORM_CONTACT_NEW,
                    context: context,
                    fields
                },
                config
            )
            .then(res => {
                toast(res?.data?.inlineMessage, {
                    theme: "colored",
                    type: "success"
                })
                window.dataLayer.push({
                    event: "generate_lead",
                    form_location: "footer"
                })
                setLoadingForm(false)
                form.reset()
            })
            .catch(err => {
                window.dataLayer.push({
                    event: "contact_submit_fail",
                    eventCategory: "form_submit"
                })
                toast("Error occur, please try again")
            })
    }

    return (
        <section className="relative z-10" id="page-form">
            <div className="container mx-auto py-16 md:py-32 lg:grid lg:grid-cols-12">
                <div className="mx-auto flex flex-col lg:col-span-10 lg:col-start-2">
                    <div className="mb-8 grid lg:mb-14">
                        <h2 className="mb-4 text-3xl text-[#1D2333] lg:text-5xl">
                            I’m interested in...
                        </h2>
                        <p className="text-base text-[#232323]/50 lg:text-xl">
                            Give us some info about your project and we’ll be in
                            touch
                        </p>
                    </div>
                    <div className="form">
                        <form onSubmit={handleOnSubmit}>
                            <fieldset className="mb-14 flex flex-wrap gap-3 lg:mb-20 lg:max-w-4xl lg:gap-6">
                                {categories.map(({ name, title }, idx) => {
                                    return (
                                        <div key={idx}>
                                            <input
                                                type="checkbox"
                                                name={name}
                                                id={name}
                                                className="peer sr-only"
                                            />
                                            <label
                                                htmlFor={name}
                                                className="inline-block cursor-pointer rounded-full border border-solid border-[#D2D2D1] py-2 px-5 text-base font-medium transition-all duration-300 hover:border-primary-color hover:bg-primary-color/20 peer-checked:border-primary-color peer-checked:bg-primary-color/20 lg:px-8 lg:py-4 lg:text-lg"
                                            >
                                                {title}
                                            </label>
                                        </div>
                                    )
                                })}
                            </fieldset>
                            <div className="mb-7 grid gap-y-6 md:mb-0 md:grid-cols-2 md:gap-x-6 lg:gap-x-[30px]">
                                <div className="group relative z-0 mb-6 w-full lg:mb-14">
                                    <input
                                        type="text"
                                        name="firstname"
                                        className="peer block w-full appearance-none border-0 border-b-2 border-[#232323]/40 border-opacity-40 bg-transparent py-2.5 px-0 text-sm text-eerie-black placeholder-transparent focus:border-primary-color focus:outline-none focus:ring-0 md:text-base"
                                        placeholder="First Name"
                                    />
                                    <label
                                        htmlFor="firstname"
                                        className="absolute top-0 -z-10 origin-[0] -translate-y-6 transform text-sm text-eerie-black opacity-40 duration-300 peer-placeholder-shown:translate-y-0 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-90 peer-focus:font-medium peer-focus:text-primary-color md:text-base"
                                    >
                                        First Name
                                    </label>
                                </div>
                                <div className="group relative z-0 mb-6 w-full lg:mb-14">
                                    <input
                                        type="text"
                                        name="lastname"
                                        className="peer block w-full appearance-none border-0 border-b-2 border-[#232323]/40 border-opacity-40 bg-transparent py-2.5 px-0 text-sm text-eerie-black placeholder-transparent focus:border-primary-color focus:outline-none focus:ring-0 md:text-base"
                                        placeholder="Last Name"
                                    />
                                    <label
                                        htmlFor="lastname"
                                        className="absolute top-0 -z-10 origin-[0] -translate-y-6 transform text-sm leading-8 text-eerie-black opacity-40 duration-300 peer-placeholder-shown:translate-y-0 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-90 peer-focus:font-medium peer-focus:text-primary-color md:text-base"
                                    >
                                        Last Name
                                    </label>
                                </div>
                            </div>
                            <div className="mb-7 grid gap-y-6 md:mb-0 md:grid-cols-2 md:gap-x-6 lg:gap-x-[30px]">
                                <div className="group relative z-0 mb-6 w-full lg:mb-14">
                                    <input
                                        type="text"
                                        name="email"
                                        className="peer block w-full appearance-none border-0 border-b-2 border-[#232323]/40 border-opacity-40 bg-transparent py-2.5 px-0 text-sm text-eerie-black placeholder-transparent focus:border-primary-color focus:outline-none focus:ring-0 md:text-base"
                                        placeholder="email"
                                        required
                                        pattern="\S+@\S+\.\S+"
                                    />
                                    <label
                                        htmlFor="email"
                                        className="absolute top-0 -z-10 origin-[0] -translate-y-6 transform text-sm text-eerie-black opacity-40 duration-300 peer-placeholder-shown:translate-y-0 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-90 peer-focus:font-medium peer-focus:text-primary-color md:text-base"
                                    >
                                        Email
                                        <span className="text-red-500">*</span>
                                    </label>
                                </div>
                                <div className="group relative z-0 mb-6 w-full lg:mb-14">
                                    <input
                                        type="text"
                                        name="phone"
                                        className="peer block w-full appearance-none border-0 border-b-2 border-[#232323]/40 border-opacity-40 bg-transparent py-2.5 px-0 text-sm text-eerie-black placeholder-transparent focus:border-primary-color focus:outline-none focus:ring-0 md:text-base"
                                        placeholder="Phone"
                                        required
                                    />
                                    <label
                                        htmlFor="name"
                                        className="absolute top-0 -z-10 origin-[0] -translate-y-6 transform text-sm leading-8 text-eerie-black opacity-40 duration-300 peer-placeholder-shown:translate-y-0 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-90 peer-focus:font-medium peer-focus:text-primary-color md:text-base"
                                    >
                                        Phone
                                        <span className="text-red-500">*</span>
                                    </label>
                                </div>
                            </div>

                            <div className="relative z-0 mb-6 w-full lg:mb-14">
                                <textarea
                                    name="message"
                                    className="peer block w-full resize-none appearance-none border-0 border-b-2 border-[#232323]/40 border-opacity-40 bg-transparent py-2.5 px-0 text-sm text-eerie-black placeholder-transparent focus:border-primary-color focus:outline-none focus:ring-0 md:text-base"
                                    placeholder="message"
                                    rows={4}
                                />
                                <label
                                    htmlFor="message"
                                    className="absolute top-0 -z-10 origin-[0] -translate-y-6 transform text-sm text-eerie-black opacity-40 duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-90 peer-focus:font-medium peer-focus:text-primary-color md:text-base"
                                >
                                    Message
                                </label>
                            </div>
                            <button
                                onClick={() => {
                                    window.dataLayer.push({
                                        event: "contact_submit",
                                        eventCategory: "form_submit_click"
                                    })
                                }}
                                type="submit"
                                className={`gray-btn button group mt-10 inline-flex items-center gap-x-2 ${
                                    loadingForm
                                        ? "pointer-events-none !bg-gray-400"
                                        : ""
                                }`}
                            >
                                submit your request
                                {loadingForm && <SpinnerLoader />}
                            </button>
                        </form>

                        <p className="mt-10 h-7">{serverState?.status?.msg}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Form
